const FIVE_MINUTES_MS = 5 * 60 * 1000;

/**
 * Build a Datadog APM trace-explorer link scoped to a POS login session.
 *
 * The backend stamps the app's API SessionId onto every APM span as
 * `@user_info.session_id`, so filtering the trace explorer by that id surfaces
 * the session's backend request traces. The SessionId is the server-issued
 * session GUID held by the app, NOT the Datadog RUM session id (which never
 * lands on APM spans).
 *
 * The link is scoped to a 10-minute window centred on link-creation time
 * (5 minutes back, 5 minutes ahead). `now` is injectable for testing.
 *
 * Returns '' when no SessionId is available so a broken link is never stored.
 */
export function getDatadogTraceUrl(sessionId?: number | string | null, now: number = Date.now()): string {
  if (!sessionId) {
    return '';
  }

  const query = encodeURIComponent(`@user_info.session_id:${sessionId}`);
  const start = now - FIVE_MINUTES_MS;
  const end = now + FIVE_MINUTES_MS;

  return `https://app.datadoghq.com/apm/traces?query=${query}&start=${start}&end=${end}`;
}
